import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { ExceptionalDay, Lot } from './';

@Model()
export default class ExceptionalRate extends ApplicationRecord {
  static jsonapiType = 'exceptional-rates';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Surcharge',
        value: 'surchage',
      },
    ];
  }

  static scopeFactory() {
    return ExceptionalRate.includes([]);
  }

  @Attr() surcharge: string;

  @HasOne() exceptionalDay: ExceptionalDay;
  @HasOne() lot: Lot;

  get formattedRate() {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(Number(this.surcharge));
  }
}
